var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBbq = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "bbq_svg__a",
  d: "M0 26.562h22.9V0H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(9 7)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#58595B",
  d: "M12.8 4.262c.3.8-.2 1.8-1.3 1.8-1 0-1.6-1-1.2-1.8.3-.8 1.2-3 1.2-3s1 2.2 1.3 3ZM16.6 5.562c-.2-.5-.7-1.7-.7-1.7s-.7 1.2-.9 1.7.1 1.1.8 1.1c.6-.1 1-.6.8-1.1M8 5.562c-.2-.5-.7-1.8-.7-1.8s-.6 1.3-.8 1.8.1 1.1.7 1.1c.7 0 1-.6.8-1.1M2.9 22.262l4.1-6.8M20.1 24.262H2.9M20.1 22.262l-4-6.7"
}), /*#__PURE__*/React.createElement("mask", {
  id: "bbq_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#bbq_svg__a"
})), /*#__PURE__*/React.createElement("path", {
  stroke: "#58595B",
  d: "M.5 26.062h2.2v-4.5H.5zM20.2 26.062h2.2v-4.5h-2.2zM2.1 8.861c.6 4.6 4.7 7.601 9.6 7.601s8.9-3 9.6-7.6z",
  mask: "url(#bbq_svg__b)"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#58595B",
  d: "M1.7 9.062v-2.1h19.6v2.1",
  mask: "url(#bbq_svg__b)"
}))));
export default SvgBbq;